// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2wpvI","controls":"styles_controls__h1NTa","charLimit":"styles_charLimit__20-kL","input":"styles_input__eME7m","send":"styles_send__3qRoj"};